import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import LinearProgress from "@material-ui/core/LinearProgress";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";
import { Redirect, useLocation } from "react-router-dom";

import useSubmitReport from "../../hooks/useSubmitReport";
import { linkToReportOverview } from "routes/report/links";

export default function ReportUploadPage() {
  const location = useLocation<any>();

  const { items, imgSrc, imgLocation } = location.state || {};

  if (!items || !imgSrc) {
    console.warn(
      "[ReportUploadPage] Missing upload state, redirecting back to report overview.",
      {
        hasLocationState: !!location.state,
        hasItems: !!items,
        itemCount: Array.isArray(items) ? items.length : 0,
        hasImgSrc: !!imgSrc,
        imgSrcLength: typeof imgSrc === "string" ? imgSrc.length : 0,
        imgLocation
      }
    );

    return <Redirect to={linkToReportOverview()} />;
  }

  return (
    <ReportUploadDialog
      items={items}
      imgSrc={imgSrc}
      imgLocation={imgLocation}
    />
  );
}

function ReportUploadDialog({
  items,
  imgSrc,
  imgLocation
}: {
  items: any;
  imgSrc: string;
  imgLocation: any;
}) {
  const { t } = useTranslation();
  const { cancelUpload, errorMessage, closeErrorDialog, sendingProgress } =
    useSubmitReport({
      imgSrc,
      online: true,
      imgLocation,
      items
    });

  return (
    <>
      <Dialog
        open={!!errorMessage}
        onClose={closeErrorDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeErrorDialog} color="primary" disableElevation>
            {t("ok_button_text")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={!errorMessage}>
        <DialogContent className={"dialogs__contentProgress"}>
          <DialogContentText id="loading-dialog-text">
            {sendingProgress} {t("record_litter_sending_progress_text")}
          </DialogContentText>
          <LinearProgress
            variant="determinate"
            color="primary"
            value={sendingProgress}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelUpload} color="secondary">
            {t("cancel_button_text")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
